<template>
    <div class="m-0 d-flex flex-wrap align-items-center mt-5" :class="mobile ? 'justify-content-center' : 'justify-content-between'">
        <h2 class="mt-2 mb-7 mx-auto">STAGIAIRES</h2>
        <div
            class="d-flex flex-wrap align-items-center mb-2"
            :class="mobile ? 'justify-content-center' : 'justify-content-between'"
            style="width:100%"
        >
            <b-form-group :style="mobile ? 'width:100%' : 'width:60%'" class="m-0" label-for="filterInput">
                <b-input-group>
                    <b-form-input
                        v-model.lazy="filter"
                        @change="onSearch"
                        type="search"
                        id="filterInput"
                        placeholder="Rechercher avec une personne avec son nom de famille"
                    />
                    <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Effacer</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
            <router-link :to="{ name: 'trainee.create' }" class="btn btn-clean btn-primary">
                Créer un nouveau stagiaire
            </router-link>
        </div>
        <b-table
            :items="trainees.data"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :current-page="1"
            :per-page="perPage"
            responsive
            hover
            style="vertical-align: middle; text-align: center"
            class="mx-0 p-0"
            :class="mobile ? 'mb-5 mt-0' : 'my-5'"
        >
            <template #cell(email_verified_at)="row">
                <div>
                    <span v-if="row.item.group" class="svg-icon svg-icon-sm svg-icon-primary">
                        <inline-svg src="/media/svg/icons/Navigation/Check.svg" />
                    </span>
                    <span v-else class="svg-icon svg-icon-sm svg-icon-danger">
                        <inline-svg src="/media/svg/icons/Navigation/Close.svg" />
                    </span>
                </div>
            </template>
            <template #cell(role)="row">
                <div>
                    {{ `${row.item.role ? row.item.role : 'Utilisateur'}` }}
                </div>
            </template>
            <template #cell(customer)="row">
                <div class="d-flex flex-column justify-content-around align-items-center" v-if="row.item.customer">
                    {{ row.item.customer.name }}
                    <span class="text-muted"> ( {{ row.item.customer.code }} ) </span>
                </div>
            </template>
            <template #cell(Action)="row">
                <router-link :to="{ name: 'user/assign', params: { user: row.item } }" replace>
                    <button
                        class="btn btn-clean btn-sm svg-icon svg-icon-primary mr-2"
                        v-b-tooltip.hover.left="'Ouvrir les accées à une classe'"
                    >
                        <inline-svg src="/media/svg/icons/General/Attachment1.svg" />
                    </button>
                </router-link>
                <!-- <router-link :to="{ name: 'a/remplacer', params: { user: row.item } }" replace> -->
                <button
                    hidden
                    class="btn btn-sm btn-icon btn-primary"
                    v-b-tooltip.hover.left="'Liste des classes suivies par le stagiaire'"
                >
                    <i class="fas fa-clipboard-list"></i>
                </button>
                <!-- </router-link> -->
            </template>
        </b-table>
        <div class="d-flex align-items-end" :class="mobile ? 'justify-content-center' : 'justify-content-between'" style="width:100%">
            <b-col sm="5" md="4">
                <b-pagination v-model="currentPage" :total-rows="trainees.meta && trainees.meta.total" :per-page="perPage" align="fill">
                </b-pagination>
            </b-col>
            <div>
                <ul class="pagination" :class="mobile ? 'mt-2' : ''">
                    <li class="page-item active">
                        <a class="page-link bg-primary"
                            >Nombre de résultats : {{ this.trainees.meta && this.trainees.meta.total ? this.trainees.meta.total : '' }}</a
                        >
                    </li>
                </ul>
            </div>
            <b-form-group
                hidden
                label="Nombre de résultats par page"
                label-for="perPageSelect"
                class="m-0 mr-2"
                :class="mobile ? 'text-center' : ''"
            >
                <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions" />
            </b-form-group>
        </div>
    </div>
</template>

<script>
import { LIST_CUSTOMER_TRAINEE } from '@/core/services/store/api/trainee.service';
import { mapGetters } from 'vuex';
//import moment from 'moment';

export default {
    data() {
        return {
            currentPage: 1,
            perPage: 10,
            user_filter: null,
            pageOptions: [],
            filter: null,
            isBusy: false,
            sortBy: 'lastname',
            sortDesc: false,
            fields: [
                { key: 'firstname', label: 'Prénom', sortable: true },
                { key: 'lastname', label: 'Nom', sortable: true },
                { key: 'customer', label: 'Établissement', sortable: true },
                { key: 'Action', label: 'Actions', sortable: false }
            ]
        };
    },
    computed: {
        ...mapGetters({ trainees: 'getCustomerTrainee' }),
        mobile() {
            return window.screen.availWidth > 992 ? false : true;
        }
    },
    watch: {
        currentPage: function() {
            return this.getTrainees();
        }
    },
    mounted() {
        this.getTrainees();
    },
    methods: {
        getTrainees() {
            var params = {
                params: {
                    page: this.currentPage,
                    'filter[lastname]': this.user_filter
                }
            };
            this.$store.dispatch(LIST_CUSTOMER_TRAINEE, params).then(result => {
                this.perPage = result.data.meta.per_page;
                this.pageOptions.push(result.data.meta.per_page, this.filter);
            });
        },
        onSearch() {
            this.user_filter = this.filter;
            this.getTrainees();
        }
    }
};
</script>
<style>
td {
    vertical-align: middle !important;
}
</style>
